/* LUMIXORA: "Passt gut dazu" im Warenkorb – Artikel per Klick hinzufügen und Warenkorb neu laden */
(function () {
document.addEventListener('click', async (event) => {
  const btn = event.target instanceof Element ? event.target.closest('[data-fl-upsell-add]') : null;
  if (!btn || btn.disabled) return;
  event.preventDefault();

  const item = btn.closest('[data-fl-upsell-item]');
  const select = item ? item.querySelector('select') : null;
  const id = Number(select ? select.value : btn.dataset.variantId);
  if (!id) return;

  const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId).filter(Boolean))];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  btn.disabled = true;
  btn.classList.add('is-loading');
  let added = false;
  try {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Fehler');
    added = true;
    const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    const { CartAddEvent } = await import('@theme/events');
    document.dispatchEvent(new CartAddEvent(cart, 'fl-upsell', {
      source: 'fl-upsell', itemCount: cart.item_count, variantId: String(id), sections: data.sections || {},
    }));
  } catch (err) {
    console.error(err);
    if (added) { window.location.reload(); return; }
    btn.classList.remove('is-loading');
    btn.disabled = false;
    btn.classList.add('is-error');
    setTimeout(() => btn.classList.remove('is-error'), 1500);
  }
});
})();
